import {XdSentry} from "../../libs/sentry/xd-sentry";

// Logs the failover incident. If there is no failover host, then this will be marked as a critical issue.
export const logFailoverIncident = ({retryHost = "", ccHost, exception = {}}) => {

    XdSentry.addBreadcrumb({
        category: "custcanv",
        message: [
            "A failover incident has occurred when attempting communication with " + ccHost + ".",
            !retryHost ? (
                "No failover host is available!"
            ) : (retryHost === ccHost) ? (
                "The request is being retried with the same host after validating connectivity. If this error persists, reboot " + ccHost + "."
            ) : (
                "After refresh, the editor will be loaded from " + retryHost + "."
            ),
        ].join(" "),
        level: (!!retryHost) ? XdSentry.Severity.Error : XdSentry.Severity.Critical,
        data: {
            exception,
        }
    });
    XdSentry.captureMessage(
        [
            "Customer's Canvas could not reach the DS server",
            !retryHost && "No failover host is available!",
        ].filter(v=>v).join(" - "),
        (!!retryHost) ? XdSentry.Severity.Error : XdSentry.Severity.Critical
    );

};
